import React, { Component } from 'react';
import propTypes from 'prop-types';

// constants
import { scriptTypes } from 'constants/scripts';

// components
import FertilityZone from 'edit/FertilityZone';
import PlantingZoneConnected from 'edit/PlantingZone';

// util
import { isEqual } from 'lodash';

class ZoneContainer extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  render() {
    const {
      activeSeedProducts,
      applicationType,
      canChooseSeedProduct,
      cropNominalWeight,
      isCheckStrip,
      isCustom,
      isEditingDisabled,
      fertilizerApplications,
      nitrogenApplicationRateType,
      onBlurProductApplicationInput,
      onChangeProductApplicationInput,
      onClickZone,
      onClickProductApplicationInput,
      onSelectSeedProduct,
      scriptTypeIsNitrogen,
      scriptType,
      seedApplications,
      selectedZoneIds,
      showLiquidApplication,
      transformNitrogenRateToFertilizer,
      validationResult,
      zoneArea,
      zoneDisplayNumber,
      zoneId,
      zoneIdentifierColor,
      zoneRef,
      zoneProductivity,
      isDeadZone
    } = this.props;
    const isSelected = selectedZoneIds.includes(zoneId);
    let content;
    switch (scriptType) {
      case scriptTypes.APPLICATION:
      case scriptTypes.FERTILITY:
        content = (
          <FertilityZone
            applicationType={applicationType}
            fertilizerApplications={fertilizerApplications}
            isCheckStrip={isCheckStrip}
            isCustom={isCustom}
            isEditingDisabled={isEditingDisabled}
            isSelected={isSelected}
            nitrogenApplicationRateType={nitrogenApplicationRateType}
            onBlurProductApplicationInput={onBlurProductApplicationInput}
            onChangeProductApplicationInput={onChangeProductApplicationInput}
            onClickProductApplicationInput={onClickProductApplicationInput}
            onClickZone={onClickZone}
            scriptType={scriptType}
            scriptTypeIsNitrogen={scriptTypeIsNitrogen}
            transformNitrogenRateToFertilizer={
              transformNitrogenRateToFertilizer
            }
            validationResult={validationResult}
            zoneArea={zoneArea}
            zoneDisplayNumber={zoneDisplayNumber}
            zoneId={zoneId}
            zoneIdentifierColor={zoneIdentifierColor}
            zoneRef={zoneRef}
            zoneProductivity={zoneProductivity}
            isDeadZone={isDeadZone}
          />
        );
        break;
      case scriptTypes.PLANTING:
        content = (
          <PlantingZoneConnected
            activeSeedProducts={activeSeedProducts}
            canChooseSeedProduct={canChooseSeedProduct}
            cropNominalWeight={cropNominalWeight}
            fertilizerApplications={fertilizerApplications}
            isCheckStrip={isCheckStrip}
            isEditingDisabled={isEditingDisabled}
            isSelected={isSelected}
            onBlurProductApplicationInput={onBlurProductApplicationInput}
            onChangeProductApplicationInput={onChangeProductApplicationInput}
            onClickProductApplicationInput={onClickProductApplicationInput}
            onClickZone={onClickZone}
            onSelectSeedProduct={onSelectSeedProduct}
            seedApplications={seedApplications}
            showLiquidApplication={showLiquidApplication}
            validationResult={validationResult}
            zoneArea={zoneArea}
            zoneDisplayNumber={zoneDisplayNumber}
            zoneId={zoneId}
            zoneIdentifierColor={zoneIdentifierColor}
            zoneRef={zoneRef}
            zoneProductivity={zoneProductivity}
            isDeadZone={isDeadZone}
          />
        );
        break;
      default:
    }
    return content;
  }
}

ZoneContainer.propTypes = {
  activeSeedProducts: propTypes.array.isRequired,
  applicationType: propTypes.string.isRequired,
  canChooseSeedProduct: propTypes.bool.isRequired,
  cropNominalWeight: propTypes.number,
  fertilizerApplications: propTypes.array.isRequired,
  isCheckStrip: propTypes.bool,
  isCustom: propTypes.bool,
  isEditingDisabled: propTypes.bool.isRequired,
  nitrogenApplicationRateType: propTypes.string,
  onBlurProductApplicationInput: propTypes.func.isRequired,
  onChangeProductApplicationInput: propTypes.func.isRequired,
  onClickProductApplicationInput: propTypes.func.isRequired,
  onClickZone: propTypes.func,
  onSelectSeedProduct: propTypes.func.isRequired,
  scriptType: propTypes.string.isRequired,
  scriptTypeIsNitrogen: propTypes.bool.isRequired,
  seedApplications: propTypes.array.isRequired,
  selectedZoneIds: propTypes.array.isRequired,
  showLiquidApplication: propTypes.bool.isRequired,
  transformNitrogenRateToFertilizer: propTypes.func,
  validationResult: propTypes.object,
  zone: propTypes.object.isRequired,
  zoneArea: propTypes.object.isRequired,
  zoneDisplayNumber: propTypes.number.isRequired,
  zoneId: propTypes.string.isRequired,
  zoneIdentifierColor: propTypes.object.isRequired,
  zoneRef: propTypes.func.isRequired,
  zoneProductivity: propTypes.number,
  isDeadZone: propTypes.bool
};

export default ZoneContainer;
